var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-notice__error"},[_vm._v(" "+_vm._s(_vm.isDevelopment ? _vm.error : this.$t('login.unknown-error'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }